import { request } from "./client";
import type { IngestAlertsResponse } from "./types";

// Refus d'ingestion du worker connecté (déduit du jeton) : envois d'un poste
// rejetés par TAWA et journées à renvoyer.
export async function listIngestAlerts(): Promise<IngestAlertsResponse> {
  return request<IngestAlertsResponse>({
    method: "GET",
    url: "/workers/ingest-alerts",
  });
}
